/**
 * Classify Course Builder / eMpowered page titles into subcourses.
 *
 * Titles like "Identity Section: Who Are You? One" become label "Who Are You?".
 * Titles like "Momentum & Mentorship: 1" become label "Momentum & Mentorship"
 * (page token only after the colon → use text before the colon).
 * Consecutive parts that share a label form one subcourse.
 */

const PAGE_WORDS =
  /^(one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve|thirteen|fourteen|fifteen|fiveteen|sixteen|\d+)$/i

/**
 * Strip a trailing page word/digit from a phrase.
 * @param {string} text
 * @returns {string}
 */
function stripTrailingPageToken(text) {
  const words = String(text || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
  if (words.length >= 1 && PAGE_WORDS.test(words[words.length - 1])) {
    words.pop()
  }
  return words.join(" ").trim()
}

/**
 * @param {string} name
 * @returns {string}
 */
export function getSubcourseLabel(name) {
  const raw = String(name || "").trim()
  if (!raw) return ""

  const colon = raw.indexOf(":")
  if (colon === -1) {
    return stripTrailingPageToken(raw) || raw
  }

  const before = raw.slice(0, colon).trim()
  const after = raw.slice(colon + 1).trim()
  const afterWithoutPage = stripTrailingPageToken(after)

  // "Momentum & Mentorship: 1" → after is only a page token → use before
  if (!afterWithoutPage) {
    return before || after || raw
  }

  return afterWithoutPage
}

/**
 * @param {Array<{ id: number, name?: string }>} partsInOrder
 * @returns {Array<{ label: string, parts: object[], firstPartId: number|null, partIds: number[] }>}
 */
export function groupPartsIntoSubcourses(partsInOrder) {
  const parts = Array.isArray(partsInOrder) ? partsInOrder : []
  const groups = []

  for (const part of parts) {
    if (!part || part.id == null) continue
    const label = getSubcourseLabel(part.name)
    const last = groups[groups.length - 1]
    if (last && last.label === label) {
      last.parts.push(part)
      last.partIds.push(part.id)
    } else {
      groups.push({
        label,
        parts: [part],
        firstPartId: part.id,
        partIds: [part.id]
      })
    }
  }

  return groups
}
